import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import { ASSET_PREFIX } from '~/constants/env'
import { useBreakpoint } from '~/hooks'
import { formatNumber } from '~/utils/numbers'
import { truncateAddress } from '~/utils/truncateAddress'
import { StyledInvitationWrapper } from './styled'
import { Props } from './types'
import { useTheme } from 'styled-components'

function getSortIcon(sortBy: string, sortOrder: string, columnKey: string) {
  if (sortBy === columnKey) {
    return sortOrder === '-' ? 'ascending-sort' : 'descending-sort'
  }
  return 'default-sort'
}

const InvitationTable: React.FC<Props> = ({
  data,
  sortBy,
  sortOrder,
  setSortBy,
  setSortOrder,
  setMyData,
}) => {
  const { isMobile } = useBreakpoint()
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <StyledInvitationWrapper>
      <table>
        <thead>
          <tr>
            <th>
              <span>{t('wallet_address')}</span>
            </th>
            <th
              onClick={() => {
                setSortBy('state')
                setSortOrder(sortOrder === '' ? '-' : '')
                setMyData({ ...data, invitations: [] })
              }}
              style={{ width: 150 }}
            >
              <div>
                <span>{t('status')}</span>
                <img
                  src={`${ASSET_PREFIX}/images/${getSortIcon(
                    sortBy,
                    sortOrder,
                    'state',
                  )}.svg`}
                  alt="sort"
                />
              </div>
            </th>
            {!isMobile && (
              <th
                onClick={() => {
                  setSortBy('power')
                  setSortOrder(sortOrder === '' ? '-' : '')
                  setMyData({ ...data, invitations: [] })
                }}
                style={{ width: 320 }}
              >
                <div>
                  <span>{t('trade_and_referral_power')}</span>
                  <img
                    src={`${ASSET_PREFIX}/images/${getSortIcon(
                      sortBy,
                      sortOrder,
                      'power',
                    )}.svg`}
                    alt="sort"
                  />
                </div>
              </th>
            )}
            {!isMobile && (
              <th
                onClick={() => {
                  setSortBy('invited_at')
                  setSortOrder(sortOrder === '' ? '-' : '')
                  setMyData({ ...data, invitations: [] })
                }}
                style={{ width: 280 }}
              >
                <div>
                  <span>{t('bond_time')}</span>
                  <img
                    src={`${ASSET_PREFIX}/images/${getSortIcon(
                      sortBy,
                      sortOrder,
                      'invited_at',
                    )}.svg`}
                    alt="sort"
                  />
                </div>
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {(data?.invitations ?? []).map((item, idx) => {
            return (
              <tr key={idx}>
                <td>{truncateAddress(item?.wallet || '')}</td>
                <td>
                  <p
                    style={{
                      color:
                        item?.state === 'PENDING'
                          ? theme.colors.textTertiary
                          : theme.colors.primary,
                    }}
                  >
                    {item?.state === 'PENDING'
                      ? t('activating')
                      : t('activated')}
                  </p>
                </td>
                {!isMobile && (
                  <td>
                    <p>{formatNumber(item?.power, 2)}</p>
                  </td>
                )}
                {!isMobile && (
                  <td>
                    <span>
                      {dayjs(item?.invitedAt * 1000).format('YYYY/MM/DD')}
                    </span>
                  </td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </StyledInvitationWrapper>
  )
}

export default InvitationTable
